import * as React from 'react';
import { magazine } from '../../../../helpers/routes';
import RegionalContent from './RegionalContent';

const mainText =
  'italist（イタリスト）では、イタリアの一流ブティックストアが厳選した最先端のファッションラグジュアリー商品を、直接イタリアのブティッ\
  クストアからお買い求めいただきます。他のECサイトでは見つからない限定商品や最新コレクションの商品を見つけることができ、マーケットプラ\
  イスよりも約３０％リーズナブルにショッピングをお楽しみいただけます！取り扱い商品はすべて、正規品・新品です。日本への商品お届けも可\
  能です。';
const actionHref = `${magazine}how-to-buy-on-italist-japanese/`;
const actionText = 'お買い物手順に着いて（日本語版）';

export default () => <RegionalContent actionHref={actionHref} actionText={actionText} mainText={mainText} />;
